export default function EFArrowRight(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M6.25651 2.35889L11.5898 7.69222L6.25651 13.0256"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
        </svg>
    );
}
